let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g6X6x")).then(() => parcelRequire('eCzgA'));